import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useResourceBasePath } from '@sh4res/bo-common/hooks';
import { buildLink } from '@sh4res/bo-common/utils/build_link';

interface Params {
  shouldRedirect?: boolean;
}

export const useB2bCompanyIdGuard = (params?: Params) => {
  const { shouldRedirect = false } = params || {};

  const navigate = useNavigate();
  const resourceBasePath = useResourceBasePath();
  const { id } = useParams<{ id: string }>();

  const companyId = useMemo(() => {
    if (id === undefined || id === '') {
      return null;
    }

    const parsedId = Number(id);

    if (Number.isNaN(parsedId)) {
      return null;
    }

    return parsedId;
  }, [id]);

  useEffect(() => {
    if (companyId === null && shouldRedirect) {
      navigate(buildLink(`${resourceBasePath}companies`, 'list'));
    }
  }, [companyId, navigate, shouldRedirect, resourceBasePath]);

  return { companyId };
};
